module.exports = "https://img.xiyuyouxi.com/saas/img/de_icon4.89896070.png";